import { createAuthTheme, getThemeColors } from '../components/UnifiedComponents/themeConfig';
import { Theme } from '@material-ui/core/styles';
import { getHostname } from './utils';

interface ThemeConfig {
  theme: 'light' | 'dark';
  primaryColor?: string;
  muiTheme: Theme;
  colors: any;
}

class ThemeService {
  private themeFile: any;

  constructor() {

  }

  setThemeFile(themeFile: any): void {
    this.themeFile = themeFile;
  }

  /**
   * Get or create theme configuration for the current hostname and theme
   */
  getThemeConfig(theme: 'light' | 'dark' = 'light'): ThemeConfig {

    // Get primary color from style config based on hostname
    const primaryColor = this.themeFile?.palette?.primary?.main;

    // Create theme once
    const muiTheme = createAuthTheme(theme, primaryColor);
    const colors = getThemeColors(theme);

    const themeConfig: ThemeConfig = {
      theme,
      primaryColor,
      muiTheme,
      colors
    };


    return themeConfig;
  }
}

export default new ThemeService();
